<template>
    <div v-loading="dataLoading">
        <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="name" label="商品名称:">
                        <el-input v-model="formData.name" placeholder="请填写名称" :maxlength="30"></el-input>
                    </el-form-item>
                    <el-form-item prop="terminal" label="展示终端:">
                        <el-checkbox-group v-model="formData.terminal">
                            <el-checkbox :label="1">APP乐迷端</el-checkbox>
                            <el-checkbox :label="3">微信小程序</el-checkbox>
                            <el-checkbox :label="2">抖音小程序</el-checkbox>
                            <el-checkbox :label="4">支付宝小程序</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item prop="cityType" label="展示城市:">
                        <el-radio-group v-model="formData.cityType">
                            <el-radio :label="0">全国展示 </el-radio>
                            <el-radio :label="1">只在下面地区展示</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="formData && formData.cityType == 1" prop="cityCodeAndNameVos" label="设置地区:">
                        <el-cascader v-model="formData.cityCodeAndNameVos" :options="cityList" filterable
                            :props="{ label: 'name', children: 'cityList', value: 'id', multiple: true, checkStrictly: true }"
                            style="width:100%" ref="cityCascader">
                        </el-cascader>
                        <small class="MT10 color-warning">
                            全国和省市同时存在活动入口时，当地省市区域内优先展示省市的活动入口，非当地省市展示全国活动入口。
                        </small>
                    </el-form-item>
                    <el-form-item prop="icon" label="入口样式:">
                        <el-radio-group v-model="formData.icon" class="icon-group">
                            <el-radio v-for="(item, index) in iconList" :key="index" :label="item">
								
                                <el-image :src="item" class="icon" v-if="item.substring(item.lastIndexOf('.') + 1).toLowerCase() != 'pag'"></el-image>
								<canvas :id="'pag'+ index"  class="pag" v-else></canvas>
                            </el-radio>
							<!-- <el-radio v-for="(item1, index1) in pagList" :key="index1" :label="item1">
							    <canvas :id="'pag'+ index1"  class="pag"></canvas>
							</el-radio> -->
                        </el-radio-group>
						
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="time1" label="展示时间段1:">
                        <span slot="label">展示时间段1：</span>
                        <el-date-picker v-model="formData.time1" type="datetimerange" range-separator="至"
                            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
                            start-placeholder="开始时间" end-placeholder="结束时间" unlink-panels>
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item prop="time2" label="展示时间段2:">
                        <span slot="label">展示时间段2：</span>
                        <el-date-picker v-model="formData.time2" type="datetimerange" range-separator="至"
                            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
                            start-placeholder="开始时间" end-placeholder="结束时间" unlink-panels>
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item prop="time3" label="展示时间段3:">
                        <span slot="label">展示时间段3：</span>
                        <el-date-picker v-model="formData.time3" type="datetimerange" range-separator="至"
                            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
                            start-placeholder="开始时间" end-placeholder="结束时间" unlink-panels>
                        </el-date-picker>
                        <!-- <small class="MT10 color-warning">
                            最晚的展示时间段到期后，会自动隐藏广告。
                        </small> -->
                    </el-form-item>
                    <el-form-item :prop="formData.type == 1 ? 'type' : 'link'"
                        :show-message="formData.type == 1 ? false : true" label="跳转目标:">
                        <el-radio-group v-model="formData.type">
                            <el-radio :label="1">活动列表页 </el-radio>
                            <el-radio :label="2">指定活动</el-radio>
                        </el-radio-group>
                        <template v-if="formData.type == 2">
                            <el-input placeholder="请填写跳转链接" v-model="formData.link" maxlength="200"></el-input>
                        </template>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="page-btns-box MT20">
            <el-button @click="goBack">返 回</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认提交</el-button>
        </div>
    </div>
</template>
<script>
import { fetchAllCity } from '@/assets/js/commonApi'
import { PAGInit } from 'libpag';
const defaultFormData = {
    name: "",
    cityType: 0,
    provinceCodes: "",
    cityCodes: "",
    cityCodeAndNameVos: [],
    icon: "",
    type: 1,
    link: "",
    showStartDate: "",
    showEndDate: "",
    firstShowStartDate: "",
    firstShowEndDate: "",
    secondShowStartDate: "",
    secondShowEndDate: "",
    time1: [],
    time2: [],
    time3: [],
    terminal: []
}
export default {
    props: {
        id: {
            type: [Number, String],
            default: ""
        }
    },
    data() {
        return {
            formData: {
                ...defaultFormData
            },
            dataLoading: false,
            btnLoading: false,
            rules: {
                name: [{ required: true, message: "请填写商品名称" }],
                // link: [{ required: true, message: "请输入跳转链接" }],
                time1: [{ required: true, message: "请输入展示时间段1" }],
                terminal: [{ required: true, message: "请选择展示终端" }],
            },
            iconList: [],
			pagList:[],
            redirect: this.$route.query.redirect || '/operation/homeEventConfig/list',
            cityOptions: [],
            cityList: []
        }
    },
    created() {
        this.getCityList();
		
		
    },
    mounted() {
        this.getIconList();
    },
    methods: {
        //获取城市列表
        async getCityList() {
            const res = await fetchAllCity({}).catch(() => { });
            const { state, result } = res.data;
            if (state == 1) {
                this.cityList = result;
            }
        },
        // 获取所有积分商品类型
        getIconList() {
            this.dataLoading = true;

            this.$request({
                url: "/home/event/icon",
                method: "POST",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
						this.iconList = result
						PAGInit({ locateFile: (file) => '/lib/' + file}).then((PAG) => {
							this.iconList.map((v1,i1) => {
								const type = v1.substring(v1.lastIndexOf('.') + 1).toLowerCase()
								if(type == "pag"){
									const url = v1;
									fetch(url)
									.then((response) => response.blob())
									.then(async (blob) => {
										const file = new window.File([blob], url.replace(/(.*\/)*([^.]+)/i, '$2'));
										const pagFile = await PAG.PAGFile.load(file);
										console.log(i1)
										document.getElementById('pag'+i1).width = pagFile.width();
										document.getElementById('pag'+i1).height = pagFile.height();
										const pagView = await PAG.PAGView.init(pagFile, '#pag'+i1);
										pagView.setRepeatCount(0);
										await pagView.play();
									});
								}
							  });
						})
						
                        if (this.id) {
                            this.getDetailData();
                        } else {
                            this.formData = {
                                ...defaultFormData,
                                icon: result.length > 0 ? result[0] : '',
                                terminal: [1,2,3,4]
                            }
                            this.dataLoading = false;
                        }
                    } else {
                        this.$message.error(msg || "获取入口样式失败");
                        this.dataLoading = false;
                    }
                })
                .catch(() => {
                    this.$message.error("获取入口样式失败");
                    this.dataLoading = false;
                })
        },
        //返回
        goBack() {
            if (this.redirect) {
                this.$router.push({
                    path: this.redirect,
                });
            } else {
                this.$router.go(-1);
            }
        },
        // 获取详情
        getDetailData() {
            this.$request({
                url: "/home/event/info",
                method: "POST",
                params: {
                    id: this.id
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.formData = {
                            ...defaultFormData,
                            ...result,
                            time1: result.showEndDate && result.showStartDate ? [result.showStartDate, result.showEndDate] : [],
                            time2: result.firstShowStartDate && result.firstShowEndDate ? [result.firstShowStartDate, result.firstShowEndDate] : [],
                            time3: result.secondShowStartDate && result.secondShowEndDate ? [result.secondShowStartDate, result.secondShowEndDate] : [],
                            terminal: result.terminal ? result.terminal.split(',').map(v => parseInt(v)) : [1,2,3,4]  //Array.of(result.terminal)
                        };

                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //表单提交
        submitForm(){
            this.$refs["formData"].validate( async (valid) => {
                if (valid) {
                    this.btnLoading = true;
                    const _form = {...this.formData}
                    const _formData = {
                        ...this.formData,
						showStartDate: _form.time1 && _form.time1 [0] || '',
						showEndDate: _form.time1 && _form.time1[1] || '',
                        firstShowStartDate: _form.time2 && _form.time2 [0] || '',
						firstShowEndDate: _form.time2 && _form.time2[1] || '',
						secondShowStartDate: _form.time3 && _form.time3 [0] || '',
						secondShowEndDate: _form.time3 && _form.time3[1] || '',	
                        terminal: _form.terminal.join(',')						
                    }	
                    _formData.provinceCodes = [];
					_formData.cityCodes  = [];
					_formData.cityCodeAndNameVos.map(item => {
						if (!_formData.provinceCodes.find(v => v == item[0]) && !item[1]) {
							_formData.provinceCodes.push(item[0]);
						}
						item[1] && _formData.cityCodes.push(item[1]);
					})
					
					_formData.provinceCodes = _formData.provinceCodes.toString();
					_formData.cityCodes = _formData.cityCodes.toString();

                    this.$request({
                        url: '/home/event/edit',
                        data: {
                            ..._formData	
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.goBack();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.icon-group {
    display: flex;
    align-content: center;

    label {
        display: flex;
        align-content: center;

        ::v-deep span {
            display: flex;
            align-content: center;
            align-items: center;
        }
    }

    .icon {
        width: 60px;
    }
	.pag{
		width: 60px;
		height: 60px;
	}
}
</style>